import { formatPrice } from './helpers/number-formatters.ts'

function basketSummaryHtml (basket) {
  if (basket.exceeded_limit) {
    return 'Error'
  }
  if (basket.total_quantity === 0) {
    const usingNewDesignHeader = !!document.querySelector("#pageHeader[data-header-version='new-design'")
    if (usingNewDesignHeader) {
      return 'Basket'
    } else {
      return ''
    }
  }
  if (basket.order_total) {
    const formattedTotalValue = formatPrice(parseFloat(basket.order_total))
    return `<span class="basket-quantity-new">${basket.total_quantity}</span> <span class="basket-extra">${formattedTotalValue}</span>`
  }

  return '(empty)'
}

function brandRefreshQuantityHtml (basket) {
  if (basket.exceeded_limit || basket.total_quantity === 0) {
    return ''
  }
  if (basket.order_total) {
    return `<div class="basket-quantity-new">${basket.total_quantity}</div>`
  }
}

function brandRefreshAmountHtml (basket) {
  if (basket.total_quantity === 0) {
    return 'Basket'
  }
  if (basket.order_total) {
    return formatPrice(parseFloat(basket.order_total))
  }
  return '(empty)'
}

function updateHeaderBasketSummary (basket) {
  const brandRefreshQuantityContainer = document.getElementById('basketQuantityContainer')
  if (brandRefreshQuantityContainer) brandRefreshQuantityContainer.innerHTML = brandRefreshQuantityHtml(basket)
  const brandRefreshAmountContainer = document.getElementById('basketAmountContainer')
  if (brandRefreshAmountContainer) brandRefreshAmountContainer.innerHTML = brandRefreshAmountHtml(basket)
  const container = document.getElementById('header-basket-summary')
  if (!container) return
  const summary = container.querySelector('.basket-summary')
  if (!summary) return
  summary.innerHTML = basketSummaryHtml(basket)
}

export default updateHeaderBasketSummary
